<template>
  <div class="page-home">
    <div class="inLogo">
      <img v-if="logoImg" :src="logoImg" alt="logo" class="logo">
    </div>
    <div class="container">
      <img :src="bgImg" alt="" class="bg">
      <!-- <LogOut/> -->
      <div class="content">
        <div class="ml15">
          <img :src="titleImg" class="title" alt="">
          <div class="line"/>
          <!-- <div class="text">国际一流的汽车数字化运营服务提供商，共建设美好车生活</div> -->
        </div>
        <div class="card owner-search" @click="toRouterPage('UserSearch')">
          <div class="card-text1">{{ convertLanage('车主实名查询') }}</div>
          <div class="card-text2">{{ convertLanage('查询个人实名信息') }}</div>
        </div>
      </div>
    </div>
    <van-overlay :show="loading">
      <van-loading size="40px" vertical>{{ convertLanage('加载中...') }}</van-loading>
    </van-overlay>
  </div>
</template>

<script>
import LogOut from '@/components/LogOut'
import { Toast } from 'vant'
import { checkEffectiveTime } from '@/api/dict'
import { RESET_PERSON, RESET_ENTERPRISE, DISPATCH_INIT_PROTOCAL } from '@/store/modules/markup'
import { convertLanage } from '@/utils/lanage'

export default {
  name: 'UserHome',
  components: {
    LogOut
  },
  data() {
    return {
      loading: false,
      bgImg: require('@/assets/images/bg.png'),
      logoImg: this.$store.getters.logo,
      titleImg: require('@/assets/images/title.png'),
      canVisit: true,
      visitTime: []
    }
  },
  created() {
    // 查询协议文件
    this.$store.dispatch(`markup/${DISPATCH_INIT_PROTOCAL}`)
    // 查询可访问时间
    this.handleFetchVisitTime()
  },
  activated() {
    this.handleFetchVisitTime()
  },
  methods: {
    /**
     * 简繁体语言转换
     */
    convertLanage(strs) {
      return convertLanage(strs)
    },
    /**
     * 获取可访问时间
     */
    async handleFetchVisitTime() {
      try {
        // 请求可访问的事件
        const { visit, startTime, endTime } = await checkEffectiveTime()
        // 记录是否可访问
        this.canVisit = visit
        // 可访问时间
        this.visitTime = [startTime, endTime]
      } catch (error) {
        // 标记当前不能访问
        this.canVisit = false
      }
    },

    /**
     * 是否有协议
     */
    notHasProtocal() {
      // =======测试环境修改-begin-=======
      // 直接返回已经没有协议需要签署
      // ======修改前:
      return !this.$store.getters.protocalMarkup || !this.$store.getters.protocalMarkup.realnameNoticeVertical
      // ======修改后:
      // return false
      // =======测试环境修改-end-=======
    },

    /**
     * 校验协议是否存在
     */
    async verifyProtocalExist() {
      // 如果当前没有上传协议，则再查一遍协议
      if (this.notHasProtocal()) {
        // 展示loading框
        this.loading = true
        try {
          await this.$store.dispatch(`markup/${DISPATCH_INIT_PROTOCAL}`)
        } catch (error) {
          console.error(error)
        }
        // 关闭loading框
        this.loading = false
        // 查询一遍后依然没有协议，则不让继续
        if (this.notHasProtocal()) {
          Toast(convertLanage('请补齐协议文件'))
          return false
        }
      }
      return true
    },

    /**
     * 跳转到路由页面
     * @param routerName 路由名称
     */
    async toRouterPage(routerName) {
      // 非服务时间
      if (!this.canVisit && (routerName === 'MarkupPersonCard' || routerName === 'MarkupEnterpriseCard')) {
        return
      }
      // 校验文件是否存在
      const isProtocalExist = await this.verifyProtocalExist()
      // 如果当前没有上传协议，则再查一遍协议
      if (!isProtocalExist) {
        return
      }
      // 先清空数据
      this.$store.commit(`markup/${RESET_PERSON}`)
      this.$store.commit(`markup/${RESET_ENTERPRISE}`)
      // 开始跳转页面
      this.$router.push({ name: routerName })
    },

    /**
    * 跳转帮助
    * @time 2022-07-14 20:24:07
    */
    toHelp() {
      this.$router.push({ name: 'Help' })
    }
  }
}
</script>

<style lang="scss">
.inLogo{
 display: flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    height: 123px;
    -ms-flex-align: center;
    align-items: center;
    padding: 0 20px 0 38px;
    background-color: #242424;
    .logo {
    width:312px;
    margin-top: -2px;
    display: inline-block;
    }
}
.page-home {
  background: url(../../assets/images/bg_home.png) 0 0 no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  .van-overlay {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .container {
    position: relative;
    padding: 0 14px;
    .bg {
      position: absolute;
      top: -30;
      right: 0;
      width: 468px;
      height: 664px;
    }
    .content {
      padding-top: 56px;
      .logo {
        width: auto;
        height: 48px;
      }
      .title {
        margin-top: 1.66667rem;
        width: 4.026667rem;
        height: 0.936667rem;
        display: block;
      }
      .line {
        width: 163px;
        height: 3px;
        margin: 38px 0 36px;
        background-image: linear-gradient(90deg, #2C38D2 0%, #61A2F9 50%, #fff 100%);

      }
      .text {
        width: 380px;
        font-size: 26px;
        line-height: 36px;
        color: #596B97;
        font-weight: 400;
      }
      .service {
        margin: 25px 0 65px 33px;
        font-size: 20px;
        font-family: MBCorpoSText-Regular;
        font-weight: 400;
        color: #596B97;
        position: relative;
        z-index: 1;
        .help {
          margin-right: 12px;
          padding-left: 24px;
          color: #2A68FF;
          background-position: 0 center;
          background-repeat: no-repeat;
          background-size: 20px 20px;
          background-image: url(../../assets/images/icon_help.png);
        }
      }
      .card {
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: center center;
        box-sizing: border-box;
        padding: 10px;
        width: 706px;
        height: 320px;
        position: relative;
        margin: 0 auto 4px;
        z-index: 1;
        padding: 89px 0 0 46px;
        position: relative;
        .card-desc {
          padding: 89px 0 0 46px;
          box-sizing: border-box;
          border-radius: 24px;
          position: absolute;
          left: 10px;
          top: 8px;
          right: 10px;
          bottom: 10px;
          display: none;
          &.locked {
            display: block;
            background: rgba(109,144,255,.2);
            backdrop-filter: blur(7px);
            box-sizing: border-box;
            background-position: center 98px;
            background-repeat: no-repeat;
            background-size: 59px 76px;
            background-image: url(../../assets/images/icon_lock.png);
            font-size: 26px;
            font-family:MBCorpoSText-Regular;
            font-weight: 500;
            color: #fff;
            text-align: center;
            padding: 192px 0 0 0;
          }
        }
        .card-text1 {
          color: #FFFFFF;
          font-size: 40px;
          line-height: 56px;
          height: 56px;
          text-shadow: 0 2px 7px #2585DC;
          font-weight: 600;
          margin-bottom: 16px;
        }
        .card-text2 {
          width: 266px;
          opacity: 0.83;
          font-family: MBCorpoSText-Regular;
          font-size: 24px;
          line-height: 33px;
          color: #FFFFFF;
          font-weight: 400;
        }
        &.new-car {
          background-image: url(../../assets/images/new_car.png);
        }
        &.enterprise {
          background-image: url(../../assets/images/enterprise.png);
        }
        &.owner-search {
          background-image: url(../../assets/images/owner-search.png);
        }
      }
      .ml15 {
        margin-left: 33px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/user.vue